import { modules } from "./modules/api";
import { creation } from "./creation/api";

export const api = {
  modules,
  creation,
};
